import React, { FC, useEffect, useState } from 'react';
import { Row, Col, Card, Typography, Space } from 'antd';
import { FileTextOutlined, BulbOutlined, CheckCircleOutlined, LoadingOutlined, CloseCircleOutlined } from '@ant-design/icons';
import ReactMarkdown from 'react-markdown';
import { signalRService } from '../../services/signalRService';

const { Title } = Typography;

const StatusIcon: FC<{ status: 'idle' | 'loading' | 'success' | 'error' }> = ({ status }) => {
    switch (status) {
        case 'loading':
            return <LoadingOutlined style={{ color: '#1890ff' }} />;
        case 'success':
            return <CheckCircleOutlined style={{ color: '#52c41a' }} />;
        case 'error':
            return <CloseCircleOutlined style={{ color: '#ff4d4f' }} />;
        default:
            return null;
    }
};

interface SpeechResultsProps {
    transcriptContent?: string;
}

export const SpeechResults: FC<SpeechResultsProps> = ({ transcriptContent }) => {
    const [insights, setInsights] = useState('');
    const [insightsStatus, setInsightsStatus] = useState<'idle' | 'loading' | 'success' | 'error'>('idle');

    const [transcript, setTranscript] = useState('');
    const [transcriptStatus, setTranscriptStatus] = useState<'idle' |'loading' | 'success' | 'error'>('idle');

    useEffect(() => {
        if (transcriptContent) {
            setTranscript(transcriptContent);
            setTranscriptStatus('success');
        }
    }, [transcriptContent]);

    useEffect(() => {
        const startSignalRConnection = async () => {
            try {
                await signalRService.startConnection(process.env.REACT_APP_SIGNALR_HUB_URL || '/AudioStreamHub');

                signalRService.onEvent('ProcessedTranscription', (data: any) => {
                    setTranscript(data.chunkTranscription);
                    setTranscriptStatus('success');
                });

                signalRService.onEvent('ProcessedInsights', (data: any) => {
                    setInsights(data.insightsInMarkdown);
                    setInsightsStatus('success');
                });	

                signalRService.onEvent('StartProcessing', (data: any) => {
                    setInsightsStatus('loading');
                    setTranscriptStatus('loading');
                });	
            } catch (error) {
                console.error('Error starting SignalR connection:', error);
                setTranscriptStatus('error');
                setInsightsStatus('error');
            }
        };

        startSignalRConnection();

        // return () => {
        //     signalRService.stop();
        // };
    }, []);

    return (
        <>
            <Row gutter={[24, 24]}>
                <Col span={12}>
                    <Card
                        title={
                            <Space>
                                <FileTextOutlined />
                                <Title level={4} style={{ margin: 0 }}>
                                    Transcripción
                                </Title>
                                <StatusIcon status={transcriptStatus} />
                            </Space>
                        }
                        bordered={false}
                        style={{ height: '80vh' }}
                        styles={{
                            body: { height: 'calc(80vh - 57px)', overflowY: 'auto' }
                        }}
                    >
                        <div
                            style={{
                                fontSize: '16px',
                                lineHeight: '1.8',
                                whiteSpace: 'pre-wrap',
                                fontFamily: 'inherit'
                            }}
                        >
                            {transcript.trim()}
                        </div>
                    </Card>
                </Col>
                <Col span={12}>
                    <Card
                        title={
                            <Space>
                                <BulbOutlined />
                                <Title level={4} style={{ margin: 0 }}>
                                    Insights
                                </Title>
                                <StatusIcon status={insightsStatus} />
                            </Space>
                        }
                        bordered={false}
                        style={{ height: '80vh' }}
                        styles={{
                            body: { height: 'calc(80vh - 57px)', overflowY: 'auto' }
                        }}
                    >
                        <div className="markdown-content" style={{ fontSize: '16px' }}>
                            <ReactMarkdown>{insights}</ReactMarkdown>
                        </div>
                    </Card>
                </Col>
            </Row>
        </>
    );
};
